export default "/react/wowBloggerIcon-4b17c8d1.svg";